import { TextField } from '@/forms-legacy'

import { useTexts } from '../hooks/useTexts'

export function Name() {
  const texts = useTexts()

  return <TextField testid="traffic-area-name" name="name" label={texts.labelName} half />
}
